import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { union } from "../../shared/src/codecs/types/union";
import { literal } from "../../shared/src/codecs/types/literal";

export const TwoFactorMethod = union([
    literal("sms"),
    literal("authenticator"),
]);
export type TTwoFactorMethodCodec = typeof TwoFactorMethod;
export type TTwoFactorMethod = TTypeOfCodec<TTwoFactorMethodCodec>;
